import CommonApp from '../../app.js';
import {userProfileManager} from '../../../util/user-profile-manager.js';
import {qas} from '../../../util/qas.js';

var addessVerificationDirective = function($scope, $uibModal, $rootScope) {
    return {
        restrict: 'E',
        scope: {
            isModalCall: '@',
            modalOpenCount: '=',
            addressData: '=',
            callbackOnSuccess: '@',
            booleanVariableToInvokeModal: '@'
        },
        controller: addessVerificationController,
        controllerAs: 'avCtrl',
        bindToController: true
    };
};

var AddessVerificationController =function addessVerificationController($scope, $uibModal, $rootScope) {
    this.$uibModal = $uibModal;
    var self = this;
    self.isAddressListVisible = false;
    self.addressList =[];


    $rootScope.qasCallback = function QAScalled(addresses) {
        self.addressList;
        var tempAddress = {};

        if (addresses instanceof Array) {
            addresses.forEach(function(item) {
                try {
                    if (null != item.addressText && undefined != item.addressText) {
                        var addressLines = item.addressText.split(',');
                        if (addressLines.length == 3) {
                            tempAddress.addressLine1 = addressLines[0];
                            tempAddress.addressLine2 = addressLines[1];

                            var cityStateZip = addressLines[2].trim();
                            tempAddress.zip = cityStateZip.match('([0-9]+)(-[0-9]+)?')[0];
                            cityStateZip = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.zip));
                            tempAddress.state = cityStateZip.substring(cityStateZip.length-2);
                            tempAddress.city = cityStateZip.substring(0, cityStateZip.indexOf(tempAddress.state));
                        }
                        self.addressList.push(tempAddress);
                    }
                } catch (err) {

                }
            });
        } else if (addresses == 'InvalidAddress') {
            self.addressInvalid = true;
            self.isAddressListVisible = false;
        } else if (addresses == 'InteractionRequired') {
            self.isAddressListVisible = false;
        } else if (addresses && addresses instanceof Object) {
            self.isAddressListVisible = false;
            modalSelf.useEnteredAddress(addressData);
            $uibModalInstance.close();
        }
    };

    qas.callQAS(self.addressData, self.addressList, $rootScope.qasCallback);


    self.modalPopupInstance = function(modalTemplateVariable, controller, windowClass) {
        var modalInstance = $uibModal.open({
            animation: true,
            backdrop: 'static',
            keyboard: false,
            templateUrl: './address-verification.pug',
            controller: controller,
            controllerAs: 'ctrl',
            windowClass: windowClass
        });
    };

    self.modalPopupInstance1 = function(modalTemplateVariable, controller, windowClass) {
        var modelPopuptemplate = require('./address-verification');
        var modalInstance = $uibModal.open({
            animation: true,
            backdrop: 'static',
            keyboard: false,
            template: modelPopuptemplate,
            controller: ['$uibModalInstance', function($uibModalInstance) {


            }],
            controllerAs: 'ctrl',
            windowClass: windowClass,
            size: 'md'
        });
    };

    self.addressVerificationModalController = function($uibModalInstance) {
        var modalSelf = this;
        modalSelf.model = {};

        modalSelf.model.addressList = self.addressList;

        modalSelf.addressData = self.addressData;
        modalSelf.ok = function() {
            $uibModalInstance.close();
        };

        modalSelf.cancel = function() {
            $uibModalInstance.dismiss();
        };

        modalSelf.goBackAndEdit = function() {
            var resetBooleanVariable = '$scope.$parent.' + self.booleanVariableToInvokeModal + ' = false;';
            eval(resetBooleanVariable);
            modalSelf.cancel();
        };

        modalSelf.goWithSelectedAddress = function(isValid, selectedObject) {
            if (isValid) {
                modalSelf.useEnteredAddress(selectedObject);
            }
        };

        modalSelf.useEnteredAddress = function(addressDataObj) {
            var resetBooleanVariable = '$scope.$parent.' + self.booleanVariableToInvokeModal + ' = false;';
            eval(resetBooleanVariable);
            modalSelf.finalAddressData = addressDataObj ? addressDataObj : modalSelf.addressData;
            modalSelf.ok();
            var setCallBackMethod = '$scope.$parent.' + self.callbackOnSuccess + '(modalSelf.finalAddressData)';
            eval(setCallBackMethod);
        };
    };

    if (self.isModalCall) {
        self.modalPopupInstance('/etc/clientlibs/mecommerce/core/main/js/address-verification/' +
            'address-verification.component.modal.verification.html',
        self.addressVerificationModalController, 'app-modal-window address-verification-popup');
    }
};

AddessVerificationController.$inject = ['$scope', '$uibModal', '$rootScope'];

CommonApp.module.controller('addessVerificationController', AddessVerificationController);

CommonApp.module.directive('addessVerificationDirective', addessVerificationDirective);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/address-verification/address-verification.js
// module id = 173
// module chunks = 0